import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    LayoutDashboard,
    Users,
    Package,
    Calendar,
    Target
} from 'lucide-react';
import { cn } from '../../lib/cn';
import { useAuth } from '../../hooks/useAuth';
import { useStore } from '../../store/useStore';

const navItems = [
    { name: 'Dashboard', href: '/', icon: LayoutDashboard, roles: ['admin', 'sales', 'commerciale', 'amministrazione', 'lettore', 'warehouse'] },
    { name: 'Clienti', href: '/customers', icon: Users, roles: ['admin', 'sales', 'commerciale', 'amministrazione'] },
    { name: 'Lead', href: '/leads', icon: Target, roles: ['admin', 'sales', 'commerciale', 'amministrazione'] },
    { name: 'Prodotti', href: '/products', icon: Package, roles: ['admin', 'sales', 'commerciale', 'amministrazione', 'lettore', 'warehouse'] },
    { name: 'Calendario', href: '/calendar', icon: Calendar, roles: ['admin', 'sales', 'commerciale', 'amministrazione'] },
] as const;

export function BottomNav() {
    const location = useLocation();
    const { profile } = useAuth();
    const newLeadCount = useStore((s) => s.newLeadCount);

    if (!profile?.role) return null;

    const userRole = profile.role as string;
    const visibleItems = navItems.filter(item => (item.roles as readonly string[]).includes(userRole));

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-white/10 px-1 py-1.5 pb-safe flex justify-around items-center shadow-[0_-4px_12px_rgba(0,0,0,0.1)]">
            {visibleItems.map((item) => {
                const isActive = location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href));
                const Icon = item.icon;

                return (
                    <Link
                        key={item.href}
                        to={item.href}
                        className={cn(
                            "relative flex flex-1 min-w-0 flex-col items-center justify-center gap-0.5 px-1 py-1 rounded-xl transition-all duration-200",
                            isActive ? "text-primary-500" : "text-neutral-400"
                        )}
                    >
                        <Icon className={cn("w-5 h-5", isActive && "filter drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]")} />
                        <span className="text-[10px] font-medium leading-none truncate max-w-full">{item.name}</span>
                        {item.href === '/leads' && newLeadCount > 0 && (
                            <span
                                className="absolute top-0 right-1.5 min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-red-500 text-[9px] font-bold text-white animate-pulse"
                                title={`${newLeadCount} nuovi lead`}
                            >
                                {newLeadCount > 9 ? '9+' : newLeadCount}
                            </span>
                        )}
                        {isActive && (
                            <div className="w-1 h-1 rounded-full bg-primary-500 mt-1" />
                        )}
                    </Link>
                );
            })}
        </nav>
    );
}
